module.exports = __webpack_public_path__ + "img/82.fed68564.png";